import React, { useEffect, useState } from 'react';

import * as hmiclientbase from '../../hmilib/hmiclientbase';
import '../../hmilib/hmiglobal';
import MonacoEditor from '../MonacoEditor/MonacoEditor';
import PopupMessage from '../PopupMessage/popupMessage';
import TreeAPC, { ITreeAPC_branch } from '../TreeAPC/TreeAPC';

import * as hmiclientbasedata from '../../hmilib/hmiclientbase';
import { IWindowUnit, WindowGlobalAreaContext } from '../WindowManager/WindowGlobalArea';

import { Button, Header, IconButton, IToastData, ToastList } from '@ixyberfree/ixybercomponents';
import { GetGuid } from 'components/common/lib';
import { colorText, MainText } from 'styles';
import ConsoleServer from '../../ConsoleServer';
import BlockPage from '../BlockPage/BlockPage';
import WindowSettingRefMethod from '../WindowSettingRefMethod/WindowSettingRefMethod';
import { AddBlockWindow } from './components/AddBlockWindow/AddBlockWindow';
import { AddNewMnemoWindow } from './components/AddNewMnemo/AddNewMnemo';
import { BindingsElement } from './components/BindingsElement/BindingsElement';
import { ContextMenu, ContextMenuStyle } from './components/ContextMenu/ContextMenu';
import { DelBlocksWindow, DelBlockWindow } from './components/DelBlockWindow/DelBlockWindow';
import { DictionaryTable } from './components/DictionaryTable/DictionaryTable';
import { EventElement } from './components/EventElement/EventElement';
import { ExeFunc } from './components/ExecutionFunc/ExecutionFunc';
import { ExportWindow } from './components/ExportWindow/ExportWindow';
import { ImportWindow } from './components/ImportWindow/ImportWindow';
import { RefDevice } from './components/RefDevice/RefDevice';
import { PropertyEditWindow } from './components/TableForEdit/PropertyEditWindow';
import { TableForEdit } from './components/TableForEdit/TableForEdit';
// import ComboBox from 'components/modules/trends/GroupTrend/ComboBox/ComboBox';

import { IComboBoxData } from 'components/modules/trends/GroupTrend/ComboBox/ComboBox';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import { useStores } from 'store';
import AddressList from './components/AddressList/AddressList';
import RefObjectsWindow from './components/RefObjectsWindow/RefObjectsWindow';
import Search from './components/Search/Search';
import css_class from './settings.module.css';

export interface ICopyPasteObject {
    id: string;
    className: string;
    method: string;
    oldId?: string;
}

export interface SelectedElem {
    id: string;
    value: string;
}

interface IProps {
    auth: {
        visibleAuth: boolean;
        authenticated: boolean;
        settingTrue: boolean;
        nameUser: string;
        callbackLogin: Function;
        callbackLogout: Function;
    };
}

interface IState {
    openWindowTree?: boolean;
    resizeTree?: boolean;
    resizeMDPoint?: number;
    widthWindowTree?: number;
    tree?: ITreeAPC_branch[];
    selectedData?: any;
    openContextMenu?: boolean;
    positionContextMenu?: { x: number; y: number };
    elemContextMenu?: JSX.Element[];
    openAddBlockMenu?: boolean;
    openDelBlockMenu?: boolean;
    idBlocks?: string[];
    openDelBlocksMenu?: boolean;
    openImportMenu?: boolean;
    openExportMenu?: boolean;
    openRefObjectWindow?: boolean;
    addBlockParentId?: string;
    addBlockListTypes?: Object;
    selectedBranch?: ITreeAPC_branch;
    parentBranch?: ITreeAPC_branch;
    openAddNewMnemo?: boolean;
    openAddRefMethod?: boolean;
    openConsoleServer?: boolean;
    reloadBase?: boolean;
    copyPasteObject?: ICopyPasteObject;
}

const Settings: React.FC<IProps> = ({ auth }) => {
    const { SystemStore } = useStores();
    //данные с сервера
    const propTree = React.useRef(new Map<string, any>());
    //типы данных по классам
    const classNameArr = React.useRef(new Map<string, any>());
    const context = React.useContext(WindowGlobalAreaContext);
    //text from Monaco
    const [textMonaco, setTextMonaco] = React.useState<string | null>(null);
    //выбранное действие в контекстном меню
    const [clickOnContextMenu, setClickOnContextMenu] = React.useState<{ action: string; id: string | undefined }>({
        action: '',
        id: ''
    });

    const [toasts, setToasts] = React.useState<IToastData[]>([]);
    const [isButtonLoading, setIsButtonLoading] = React.useState<boolean>(false);

    const [state, setState] = React.useState<IState>({
        openWindowTree: true,
        resizeTree: false,
        resizeMDPoint: 0,
        widthWindowTree: 400,
        tree: [],
        selectedData: {},
        openContextMenu: false,
        positionContextMenu: { x: 0, y: 0 },
        elemContextMenu: [],
        openAddBlockMenu: false,
        addBlockParentId: '',
        addBlockListTypes: {},
        openAddNewMnemo: false,
        openAddRefMethod: false,
        openConsoleServer: false,
        openRefObjectWindow: false,
        openDelBlockMenu: false,
        openDelBlocksMenu: false,
        openImportMenu: false,
        openExportMenu: false,
        reloadBase: true,
        copyPasteObject: { id: '', className: '', method: '' }
    });
    //Открытие консоли alt + i
    function logKey(e: any) {
        e = e || window.event;
        if (e.altKey && e.keyCode == 73) {
            const screenHeight = window.innerHeight;
            const screenWidth = window.innerWidth;

            let wnd: IWindowUnit = {
                x: screenWidth / 2 - 860 / 2,
                y: screenHeight / 2 - 510 / 2,
                mode: 'free',
                children: (
                    <ConsoleServer
                        closeCB={() => {
                            context.closeWindowUnit(wnd);
                        }}
                    />
                ),
                keyID: generateRandomKey()
            };
            context.createWindowUnit(wnd);
        }
        return true;
    }

    //Инициальизация подключения к base
    async function InitSettings() {
        setState((prevState) => ({
            ...prevState,
            openWindowTree: true,
            resizeTree: false,
            resizeMDPoint: 0,
            widthWindowTree: 400,
            tree: [],
            selectedData: {},
            openContextMenu: false,
            positionContextMenu: { x: 0, y: 0 },
            elemContextMenu: [],
            openAddBlockMenu: false,
            openImportMenu: false,
            addBlockParentId: '',
            addBlockListTypes: {},
            openAddNewMnemo: false,
            openAddRefMethod: false,
            reloadBase: false
        }));

        await initTree();
        const data = await getObjectData('', 1);
        genTree(data, classNameArr.current.get(data.ClassName));
    }

    //Основной стейт при монтирование компонента
    React.useEffect(() => {
        console.debug('vis Sett ' + auth.settingTrue);
        document.addEventListener('keydown', logKey);
        // ReloadBase();
        return () => {
            document.removeEventListener('keydown', logKey);
        };
    }, []);

    useEffect(() => {
        let isMounted = true;
        let timeoutId: NodeJS.Timeout | null = null;

        if (SystemStore.loadState) {
            const checkPingingAndLoad = async () => {
                const load = await hmiclientbase.SettingsGetIsLoaded();
                if (load && isMounted) {
                    baseLoad();
                } else if (isMounted) {
                    timeoutId = setTimeout(checkPingingAndLoad, 5000);
                }
            };

            checkPingingAndLoad();
        }

        return () => {
            isMounted = false;
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [SystemStore.loadState]);

    const baseLoad = () => {
        if (!isEmpty(hmiclientbase.GetBase())) {
            InitSettings();
        } else {
            setTimeout(() => {
                baseLoad();
            }, 5000);
        }
    };

    const timerIdRef = React.useRef<NodeJS.Timeout | null>(null);

    React.useEffect(() => {
        const timer = async () => {
            if (state.selectedData.id !== undefined) {
                try {
                    const newData = await getObjectData(state.selectedData.id, 1, undefined, true);
                    const dataInterface = await getObjectData(
                        '7d0ef11d-3d83-4361-9d7b-cfe1feb2b411',
                        1,
                        undefined,
                        true
                    );

                    if (newData) {
                        let parent = propTree.current.get(state.selectedData.pid);

                        const updatedBranch = updateBranchConf(
                            newData,
                            classNameArr.current.get(newData.ClassName),
                            parent,
                            state.selectedBranch?.stateBranch
                        );

                        const dataInterfaceBranch = updateBranchConf(
                            dataInterface,
                            classNameArr.current.get(dataInterface.ClassName)
                        );

                        const updateBranch = (currentBranch: ITreeAPC_branch): ITreeAPC_branch => {
                            if (currentBranch.id === updatedBranch.id) {
                                return {
                                    ...currentBranch,
                                    ...updatedBranch
                                };
                            }

                            if (currentBranch.id === dataInterfaceBranch.id) {
                                return {
                                    ...currentBranch,
                                    ...dataInterfaceBranch,
                                    stateBranch: currentBranch.stateBranch,
                                    children: currentBranch.children.map((child, index) => {
                                        const dataChild = dataInterfaceBranch.children[index];
                                        const newChild = {
                                            ...dataChild,
                                            children: child.children,
                                            stateBranch: child.stateBranch
                                        };
                                        return newChild;
                                    })
                                };
                            }

                            return {
                                ...currentBranch,
                                children: currentBranch.children.map(updateBranch)
                            };
                        };

                        setState((prevState) => ({
                            ...prevState,
                            tree: prevState.tree?.map(updateBranch) || [],
                            selectedData: { ...newData },
                            selectedBranch: updatedBranch
                        }));
                    }
                } catch (error) {
                    console.error('Ошибка при обновлении данных:', error);
                }
            }
        };

        timerIdRef.current = setTimeout(timer, 5000);

        return () => {
            if (timerIdRef.current !== null) {
                clearTimeout(timerIdRef.current);
            }
        };
    }, [state.selectedData, state.selectedBranch]);

    async function getBranchData(branch: ITreeAPC_branch, id: string, state?: boolean) {
        const data = await getObjectData(id, 1);
        let updatedBranch: ITreeAPC_branch;

        const updateBranch = (currentBranch: ITreeAPC_branch): ITreeAPC_branch => {
            if (currentBranch.id === branch.id) {
                const parent = propTree.current.get(branch.pid!);
                updatedBranch = updateBranchConf(data, classNameArr.current.get(data.ClassName), parent, state);

                return {
                    ...currentBranch,
                    ...updatedBranch,
                    children: updatedBranch.children,
                    stateBranch: state
                };
            }

            return {
                ...currentBranch,
                children: currentBranch.children.map(updateBranch)
            };
        };

        setState((prevState) => {
            return {
                ...prevState,
                tree: prevState.tree?.map(updateBranch) || [],
                selectedData: data,
                selectedBranch: updatedBranch
            };
        });
    }

    //обработка запросов на получение данных с сервера ...Старый вариант с мутацией, дерево странно себя ведет (не обновляются стейты)!!!!
    // async function getBranchData(branch: ITreeAPC_branch, id: string, state?: boolean) {
    //     const data = await getObjectData(id, 1);
    //     if (!branch.children?.find((item) => item.name === data.name)) {
    //         const tempBranch = updateBranchConf(data, classNameArr.current.get(data.ClassName), branch, state);
    //         branch.children = tempBranch.children;
    //         branch.stateBranch = tempBranch.stateBranch;
    //     }

    //     setState((prevState) => ({
    //         ...prevState,
    //         tree: [...prevState.tree || []],
    //         selectedData: data,
    //         selectedBranch: branch
    //     }));
    // }

    async function getObjClass(ClassName: string) {
        let res: any = {};
        if (!classNameArr.current.has(ClassName)) {
            //нет в загруженных type, запрашиваем
            let type = await hmiclientbase.SettingsGetType(ClassName);
            if (ClassName) {
                classNameArr.current.set(ClassName, type[ClassName]);
                res = type[ClassName];
            }
        } else {
            res = classNameArr.current.get(ClassName);
        }
        return res;
    }

    async function getObjectsData(ids: string[]) {
        return await hmiclientbase.SettingsGetObjectsDto(ids);
    }

    async function getObjectData(id?: string, diveToLevel?: number, curLevel?: number, updateForce: boolean = false) {
        diveToLevel = diveToLevel === undefined ? 0 : diveToLevel;
        const level = curLevel === undefined ? 0 : curLevel + 1;
        id = id ?? '';
        let object: any;

        if (!propTree.current.has(id) || updateForce) {
            //нет в загруженных data, запрашиваем
            if (id == '7d0ef11d-3d83-4361-9d7b-cfe1feb2b411') {
                object = await hmiclientbase.SettingsGetObject(id);
            } else {
                object = await hmiclientbase.SettingsGetObjectDto(id);
            }

            if (object.length !== 0) {
                propTree.current.set(object.id, object);
            }
        } else {
            const existedData: any = propTree.current.get(id);
            if (existedData.id != undefined && existedData.id != id) {
                console.warn('Буфер не корректные данные по id=' + id);
                object = await hmiclientbase.SettingsGetObjectDto(id);
                propTree.current.set(object.id, object);
            } else {
                object = existedData;
            }
        }

        const objClass = await getObjClass(object.ClassName);

        if (diveToLevel > level) {
            for (let i = 0; i < objClass.length; i++) {
                if (typeof object[objClass[i].Name] === 'object' && object[objClass[i].Name] !== null) {
                    if (objClass[i].ReturnTypes[0].indexOf('System.Collections.Generic.Dictionary') > -1) {
                        const childIds: any[] = [];

                        for (let objName in object[objClass[i].Name]) {
                            const childObj = object[objClass[i].Name][objName];

                            const objId = childObj.id;

                            if (objId !== undefined) {
                                if (!propTree.current.has(objId)) {
                                    childIds.push(childObj.id);
                                } else {
                                    if (Object.keys(childObj).length <= 3) {
                                        const getObj = propTree.current.get(childObj.id);
                                        object[objClass[i].Name][objName] = { ...getObj } as any;
                                    }
                                }
                            }
                        }

                        if (childIds.length !== 0) {
                            const childObjects = await getObjectsData(childIds);
                            Object.entries(childObjects).forEach((obj: any[]) => {
                                object[objClass[i].Name][obj[0]] = obj[1];
                                propTree.current.set(obj[1].id, obj[1]);
                            });
                        }
                    } else {
                        if (object[objClass[i].Name].id !== undefined) {
                            let temp: any = await getObjectData(object[objClass[i].Name].id, diveToLevel, level);
                            object[objClass[i].Name] = temp;
                        }
                    }
                }
            }
        }

        return object;
    }

    React.useEffect(() => {
        clickOnContext(clickOnContextMenu.action, clickOnContextMenu.id);
    }, [clickOnContextMenu]);

    async function clickOnContext(type: string, id?: string) {
        switch (type) {
            case 'add': {
                setState((prevState) => ({
                    ...prevState,
                    openAddBlockMenu: true
                }));
                closeContextMenu();
                break;
            }
            case 'del': {
                setState((prevState) => ({
                    ...prevState,
                    openDelBlockMenu: true
                }));
                closeContextMenu();
                break;
            }
            case 'editMnemo': {
                if (id !== undefined) {
                    let obj = propTree.current.get(id);
                    if (obj.file !== null && obj.file.indexOf('.svg') > 0) {
                        const filePath = obj.file.replace(/\\/g, '/').replace(/"/g, '');
                        window.open('/ixyber/vision/EditorVision/page?file=' + filePath);
                    } else {
                        alert('Задайте имя файла мнемосхемы');
                    }
                }
                closeContextMenu();
                break;
            }
            case 'cut': {
                if (state.addBlockParentId) {
                    setState((prevState) => ({
                        ...prevState,
                        copyPasteObject: {
                            id: prevState.addBlockParentId || '',
                            oldId: prevState.selectedBranch?.pid || '',
                            className: prevState.selectedData.ClassName,
                            method: 'cut'
                        }
                    }));
                }
                closeContextMenu();
                break;
            }
            case 'copy': {
                if (state.addBlockParentId) {
                    setState((prevState) => ({
                        ...prevState,
                        copyPasteObject: {
                            id: prevState.addBlockParentId || '',
                            className: prevState.selectedData.ClassName,
                            method: 'copy'
                        }
                    }));
                }
                closeContextMenu();
                break;
            }
            case 'paste': {
                if (state.addBlockParentId && state.copyPasteObject) {
                    if (state.copyPasteObject.method === 'cut') {
                        const PasteObject = async () => {
                            if (state.addBlockParentId && state.copyPasteObject) {
                                await hmiclientbase.PasteObject(state.copyPasteObject.id, state.addBlockParentId);
                                const objects = await hmiclientbase.SettingsGetObjectsDto([
                                    state.addBlockParentId,
                                    state.copyPasteObject.oldId!,
                                    state.copyPasteObject.id
                                ]);
                                for (const [_, value] of Object.entries(objects) as [any]) {
                                    propTree.current.set(value.id, value);
                                    if (value.id == state.copyPasteObject.oldId) {
                                        await getBranchData(value, value.id);
                                    }
                                }
                                if (state.selectedBranch?.id) {
                                    await getBranchData(
                                        state.selectedBranch,
                                        state.selectedBranch.id,
                                        state.selectedBranch.stateBranch
                                    );
                                }
                            }
                        };

                        PasteObject();
                    } else if (state.copyPasteObject.method === 'copy') {
                        alert('Копирование будет в новом релизе');
                    }
                    setState((prevState) => ({
                        ...prevState,
                        copyPasteObject: undefined
                    }));
                }
                closeContextMenu();
                break;
            }
            case 'import': {
                setState((prevState) => ({
                    ...prevState,
                    openImportMenu: true
                }));
                closeContextMenu();
                break;
            }
            case 'export': {
                setState((prevState) => ({
                    ...prevState,
                    openExportMenu: true
                }));
                closeContextMenu();
                break;
            }
            case 'refs': {
                setState((prevState) => ({
                    ...prevState,
                    openRefObjectWindow: true
                }));
                closeContextMenu();
                break;
            }
        }
    }

    async function openContextMenu(
        e: React.MouseEvent,
        id: string,
        delObj?: boolean,
        selectedBranch?: ITreeAPC_branch,
        parentBranch?: ITreeAPC_branch
    ) {
        e.preventDefault();
        let obj = propTree.current.get(id);
        let listTypes: any = {};

        let posX = e.pageX;
        let posY = e.pageY;

        await hmiclientbase.SettingsGetChildTypes(id).then((data: any) => {
            if (data.New !== undefined) {
                listTypes = data;
            }
        });

        const createButton = (key: string, action: string, label: string, id?: string) => (
            <ContextMenuStyle
                key={key}
                onClick={() => {
                    setClickOnContextMenu((prev) => ({
                        ...prev,
                        action: action,
                        id: id
                    }));
                }}>
                <MainText size={12} color={colorText.main}>
                    {label}
                </MainText>
            </ContextMenuStyle>
        );

        const addButton = createButton('addButton', 'add', 'Добавить блок');
        const delButton = createButton('delButton', 'del', 'Удалить блок');
        const cutButton = createButton('cutButton', 'cut', 'Вырезать');
        const pasteButton = createButton('pasteButton', 'paste', 'Вставить');
        const openMnemoEditorButton = createButton('openMnemoEditorButton', 'editMnemo', 'Редактировать', id);
        const importButton = createButton('importButton', 'import', 'Импорт');
        const exportButton = createButton('exportButton', 'export', 'Экспорт');
        const refObjButton = createButton('refObjButton', 'refs', 'Ссылки');

        setState((prevState) => {
            let tempState: IState = {
                ...prevState,
                openContextMenu: false,
                positionContextMenu: { x: posX, y: posY },
                elemContextMenu: [],
                addBlockParentId: id,
                addBlockListTypes: listTypes,
                // selectedBranch: selectedBranch,
                parentBranch: parentBranch
            };

            let c = [];
            for (let key in listTypes) {
                c.push(key);
            }

            if (c.length > 0) {
                tempState.openContextMenu = true;
                tempState.elemContextMenu?.push(addButton);
            }

            if (obj.ClassName === 'iXyberBaseLib.Mnemo' || obj.ClassName === 'iXyberBaseLib.MnemonicDiagram') {
                tempState.openContextMenu = true;
                tempState.elemContextMenu?.push(openMnemoEditorButton);
            }

            if (delObj) {
                tempState.openContextMenu = true;
                tempState.elemContextMenu?.push(delButton);
                tempState.elemContextMenu?.push(cutButton);
                tempState.elemContextMenu?.push(refObjButton);
            }

            if (
                obj.ClassName === 'iXyberBaseLib.Block' ||
                obj.ClassName === 'iXyberBaseLib.MnemonicDiagram' ||
                obj.ClassName === 'iXyberBaseLib.MnemonicDiagramFolder' ||
                obj.ClassName === 'iXyberBaseLib.Templates'
            ) {
                tempState.openContextMenu = true;
                tempState.elemContextMenu?.push(importButton);
                tempState.elemContextMenu?.push(exportButton);
            }
            if (prevState.copyPasteObject) {
                if (listTypes) {
                    if (listTypes['New']?.indexOf(prevState.copyPasteObject.className) != -1) {
                        tempState.elemContextMenu?.push(pasteButton);
                    }
                }
            }
            return tempState;
        });
    }

    function closeContextMenu() {
        setState((prevState) => ({
            ...prevState,
            openContextMenu: false
        }));
    }

    function removeBranchById(branch: ITreeAPC_branch, idToRemove: string): ITreeAPC_branch | null {
        if (branch.id === idToRemove) {
            return null;
        }

        if (branch.children) {
            branch.children = branch.children.filter((child) => {
                const updatedChild = removeBranchById(child, idToRemove);
                return updatedChild !== null;
            });
        }

        return branch;
    }

    async function DelBlock(idBlock: string, deleteAll: boolean) {
        if (idBlock && idBlock !== '') {
            setIsButtonLoading(true);
            await hmiclientbase.SettingsDeleteObject(idBlock, deleteAll).then((res: string) => {
                if (res === 'true') {
                    if (state.parentBranch) {
                        if (state.selectedBranch?.id) {
                            let idToRemove = state.selectedBranch?.id;
                            propTree.current.delete(state.selectedBranch.id);
                            if (state.parentBranch?.id) {
                                const parent = propTree.current.get(state.parentBranch.id);
                                const fieldName = findPropertyName(classNameArr.current, state.selectedData.ClassName);
                                delete parent[fieldName][state.selectedBranch.name];
                            }
                            setState((prevState) => ({
                                ...prevState,
                                tree: (prevState.tree || [])
                                    .map((branch) => removeBranchById(branch, idToRemove))
                                    .filter((branch) => branch !== null) as ITreeAPC_branch[],
                                openDelBlockMenu: false,
                                selectedData: {},
                                selectedBranch: {} as ITreeAPC_branch,
                                parentBranch: {} as ITreeAPC_branch
                            }));
                            showToast(`Объект ${state.selectedBranch!.name} удален`);
                        }
                    }
                } else {
                    setState((prevState) => ({
                        ...prevState,
                        openDelBlockMenu: false
                    }));
                    showToast(`Ошибка при удалении объекта ${state.selectedBranch!.name}`);
                }
            });
        } else {
            setState((prevState) => ({
                ...prevState,
                openDelBlockMenu: false
            }));
        }
        setIsButtonLoading(false);
    }

    async function DelBlocks(idBlocks: string[], deleteAll: boolean) {
        for (let idBlock of idBlocks) {
            if (idBlock && idBlock !== '') {
                await hmiclientbase.SettingsDeleteObject(idBlock, deleteAll).then((res: string) => {});
            }
        }
        ///Переделать на запросы
        location.reload();
    }

    async function ExportObject(
        pid: string,
        separator: string,
        namesToSend: any[],
        typesToSend: any[],
        isExportAll: boolean
    ) {
        if (pid != null && separator != null) {
            setState((prevState) => ({
                ...prevState,
                reloadBase: true
            }));
            hmiclientbase.ExportObject(pid, separator, namesToSend, typesToSend, isExportAll).then(() => {
                setState((prevState) => ({
                    ...prevState,
                    reloadBase: false
                }));
            });
        }

        setState((prevState) => ({
            ...prevState,
            openExportMenu: false
        }));
    }

    async function ImportObject(pid: string, data: any) {
        if (pid != null && data != null) {
            setState((prevState) => ({
                ...prevState,
                reloadBase: true,
                openImportMenu: false
            }));
            const importResponse = await hmiclientbase.ImportObject(pid, data);
            const message = importResponse.IsSuccessImport
                ? `${importResponse.Message} ${importResponse.SuccessAddedCount}`
                : `${importResponse.Message} Успешно импортировано блоков: ${importResponse.SuccessAddedCount}`;
            showToast(message);
            setState((prevState) => ({
                ...prevState,
                reloadBase: false
            }));
        }
    }

    const symbols = ['.', '/', '\\', ':', ';', ',', '$'];

    const updateTreeBranch = (tree: ITreeAPC_branch[], newObj: any, data: any, state: boolean | undefined) => {
        let updatedBranch: any;

        const updateBranch = (currentBranch: ITreeAPC_branch): ITreeAPC_branch => {
            if (currentBranch.id === newObj.pid) {
                const parent = propTree.current.get(currentBranch.pid!);

                updatedBranch = updateBranchConf(data, classNameArr.current.get(data.ClassName), parent, state);
                return {
                    ...currentBranch,
                    children: updatedBranch.children,
                    stateBranch: updatedBranch.stateBranch
                };
            }

            return {
                ...currentBranch,
                children: currentBranch.children?.map(updateBranch) || []
            };
        };

        return { tree: tree.map(updateBranch), updatedBranch: updatedBranch };
    };

    const isEmpty = (obj: any) => {
        for (let key in obj) {
            // если тело цикла начнет выполняться - значит в объекте есть свойства
            return false;
        }
        return true;
    };

    async function AddBlock(name: string, type: string, style: string, templateBindings: string = '') {
        if (state.selectedBranch?.children) {
            const hasChildWithName = state.selectedBranch.children.some(
                (child) => child.name.toUpperCase() === name.toUpperCase()
            );
            const invalidName = name.length == 0 || symbols.some((x) => name.includes(x)) ? true : false;

            if (hasChildWithName || invalidName) {
                if (invalidName) {
                    if (name.length == 0) {
                        showToast(`Введите имя блока`);
                    } else {
                        showToast(`Нельзя использовать системные разделители: \\ / . , : ; $`);
                    }
                } else {
                    showToast(`Предупреждение: Объект с именем "${name}" уже существует!`);
                }
            } else {
                if (name && name !== '') {
                    let newObj: any;

                    setIsButtonLoading(true);
                    if (style == 'Template') {
                        newObj = await hmiclientbase
                            .CreateObjectTemplate(name, type, state.addBlockParentId!, templateBindings)
                            .then((res: any) => {
                                if (res != null) {
                                    showToast(`Объект ${name} добавлен`);
                                }
                                return res;
                            });
                        setIsButtonLoading(false);
                    } else {
                        newObj = await hmiclientbase
                            .SettingsCreateObject(name, type, state.addBlockParentId!, style)
                            .then((res: any) => {
                                if (res != null) {
                                    showToast(`Объект ${name} добавлен`);
                                }
                                return res;
                            });
                        setIsButtonLoading(false);
                    }

                    // let promObjClass: any = await new Promise((res) => {
                    //     if (!classNameArr.current.has(newObj.ClassName)) {
                    //         //нет в загруженных type, запрашиваем
                    //         hmiclientbase.SettingsGetType(newObj.ClassName).then((type: any) => {
                    //             res(type[newObj.ClassName]);
                    //             classNameArr.current.set(newObj.ClassName, type[newObj.ClassName]);
                    //         });
                    //     } else {
                    //         res(classNameArr.current.get(newObj.ClassName));
                    //     }
                    // });

                    const fieldName = findPropertyName(classNameArr.current, newObj.ClassName);

                    const parentObj = propTree.current.get(state.addBlockParentId!);
                    parentObj[fieldName][newObj.name] = newObj;

                    if (!isEmpty(newObj) && newObj.id !== undefined) {
                        if (!propTree.current.has(newObj.id)) {
                            propTree.current.set(newObj.id, newObj);
                        }

                        // let tempBranch = updateBranchConf(newObj, promObjClass, state.selectedBranch);
                        if (state.selectedBranch) {
                            // const newStateChildren = state.selectedBranch.children;
                            // newStateChildren?.push(tempBranch);
                            // newStateChildren?.sort(function (a, b) {
                            //     if (a.class && b.class) {
                            //         if (b.class < a.class) {
                            //             return 1;
                            //         }
                            //         if (b.class > a.class) {
                            //             return -1;
                            //         }
                            //     }
                            //     if (a.name < b.name) {
                            //         return -1;
                            //     }
                            //     if (a.name > b.name) {
                            //         return 1;
                            //     }

                            //     return 0;
                            // });

                            // const name = state.selectedBranch.name;
                            // const type = state.selectedBranch.type;

                            // const data = await getObjectData(parentObj.id, 1);

                            setState((prevState) => {
                                const { tree, updatedBranch } = updateTreeBranch(
                                    prevState.tree || [],
                                    newObj,
                                    parentObj,
                                    prevState?.selectedBranch?.stateBranch
                                );

                                return {
                                    ...prevState,
                                    tree: tree,
                                    openAddBlockMenu: false,
                                    selectedBranch: updatedBranch
                                };
                            });
                        }
                    } else {
                        setState((prevState) => ({
                            ...prevState,
                            openAddBlockMenu: false
                        }));
                    }
                } else {
                    setState((prevState) => ({
                        ...prevState,
                        openAddBlockMenu: false
                    }));
                }
            }
        }
    }

    function findPropertyName(data: any, className: string) {
        for (let itemType of data) {
            for (let returnType of itemType[1]) {
                if (
                    returnType.ReturnTypes[0].includes(className) &&
                    returnType.ReturnTypes[0].includes('System.Collections.Generic.Dictionary')
                ) {
                    return returnType.Name;
                }
            }
        }
        return null;
    }

    function AddNewMnemo(name: string) {
        if (name !== '') {
        } else {
        }
        setState((prevState) => ({
            ...prevState,
            openAddNewMnemo: false
        }));
    }

    function findType(typeArr: any, key: string): any {
        return typeArr.filter((elem: any) => {
            return elem.Name === key;
        })[0];
    }
    //

    function updateBranchConf(obj: any, type: any, parentBranch?: ITreeAPC_branch, stateBranch: boolean = false): any {
        let ignoreTypeTree: string[] = [
            'iXyberBaseLib.Events.EventElement',
            'System.Collections.Generic.HashSet`1[[System.String,'
        ];
        function isEmpty(obj: any) {
            if (ignoreTypeTree.find((i) => i.includes(obj.ClassName))) {
                return true;
            }

            for (let key in obj) {
                // если тело цикла начнет выполняться - значит в объекте есть свойства
                return false;
            }
            return true;
        }

        let branch: ITreeAPC_branch = {
            id: obj.id,
            pid: obj.pid,
            class: obj.ClassName,
            name: obj.name,
            shape: obj.shape ? obj.shape : '',
            type: 'folder',
            children: [],
            iconUrl: '/ixyber/vision/static/images/tree_icon/' + obj.icon,
            pointer: true,
            path: obj.path,
            stateBranch: stateBranch,
            clickCallBack: (state: boolean) => {
                obj.id && getBranchData(branch, obj.id, state);
            },
            contextCallBack: (e: React.MouseEvent, state: boolean) => {
                obj.id && getBranchData(branch, obj.id, state);
                openContextMenu(e, obj.id, true, branch, parentBranch);
            }
        };

        if (obj.ClassName == 'iXyberBaseLib.Parameter') {
            let childrenParameters = getChildrenParameters(obj.sourceIn);
            branch.address = childrenParameters[0].address;
            branch.enable = childrenParameters[0].enable;
            branch.quality = obj.quality;
        } else if (obj.ClassName == 'iXyberBaseLib.Source') {
            branch.address = obj.address;
        } else if (obj.ClassName.indexOf('iXyberBaseLib.Interfaces.Clients') > -1) {
            if (obj.state != null && obj.state != undefined) {
                branch.quality = obj.state;
                obj.state == 4 ? (branch.enable = true) : (branch.enable = false);
            }
        }

        for (let key in obj) {
            if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key]) && key != 'parent') {
                if (!isEmpty(obj[key])) {
                    let typeArr = findType(type, key).ReturnTypes;
                    if (typeArr[0].indexOf('System.Collections.Generic.Dictionary') > -1) {
                        for (let dKey in obj[key]) {
                            if (obj[key][dKey].id !== undefined) {
                                let mBranch: ITreeAPC_branch = {
                                    id: obj[key][dKey].id,
                                    pid: obj[key][dKey].pid,
                                    class: obj[key][dKey].ClassName,
                                    name: obj[key][dKey].name,
                                    shape: obj[key][dKey].shape ? obj[key][dKey].shape : '',
                                    type: 'folder',
                                    children: [],
                                    path: obj[key][dKey].path,
                                    stateBranch: false,
                                    iconUrl: '/ixyber/vision/static/images/tree_icon/' + obj[key][dKey].icon,
                                    pointer: true,
                                    clickCallBack: (state: boolean) => {
                                        obj[key][dKey].id && getBranchData(mBranch, obj[key][dKey].id, state);
                                    },
                                    contextCallBack: (e: React.MouseEvent, state: boolean) => {
                                        obj[key][dKey].id && getBranchData(mBranch, obj[key][dKey].id, state);
                                        openContextMenu(e, obj[key][dKey].id, true, mBranch, branch);
                                    }
                                };

                                if (obj[key][dKey].ClassName == 'iXyberBaseLib.Parameter') {
                                    let childrenParameters = getChildrenParameters(obj[key][dKey].sourceIn);
                                    mBranch.address = childrenParameters[0].address;
                                    mBranch.enable = childrenParameters[0].enable;
                                    mBranch.quality = obj[key][dKey].quality;
                                } else if (obj[key][dKey].ClassName == 'iXyberBaseLib.Source') {
                                    mBranch.address = obj[key][dKey].address;
                                } else if (typeArr[0].indexOf('iXyberBaseLib.Interfaces.Clients') > -1) {
                                    // mBranch.enable = obj[key][dKey].state;
                                    if (obj[key][dKey].state != null && obj[key][dKey].state != undefined) {
                                        mBranch.quality = obj[key][dKey].state;
                                        obj[key][dKey].state == 4 ? (mBranch.enable = true) : (mBranch.enable = false);
                                    }
                                }

                                if (branch.children !== undefined) {
                                    branch.children.push(mBranch);
                                }
                            }
                        }
                    } else if (
                        typeArr[0].indexOf('System.Collections.Generic.HashSet`1[[System.String') == -1 &&
                        typeArr[0].indexOf('System.Collections.Generic.List`1[[iXyberBaseLib.Binding') == -1
                    ) {
                        let mBranch: ITreeAPC_branch = {
                            id: obj[key].id,
                            pid: obj[key].pid,
                            class: obj[key].ClassName,
                            name: obj[key].name,
                            shape: obj[key].shape ? obj[key].shape : '',
                            type: 'folder',
                            children: [],
                            path: obj[key].path,
                            stateBranch: false,
                            iconUrl: '/ixyber/vision/static/images/tree_icon/' + obj[key].icon,
                            pointer: true,
                            clickCallBack: (state: boolean) => {
                                obj[key].id && getBranchData(mBranch, obj[key].id, state);
                            },
                            contextCallBack: (e: React.MouseEvent, state: boolean) => {
                                obj[key].id && getBranchData(mBranch, obj[key].id, state);
                                openContextMenu(e, obj[key].id, false, mBranch, branch);
                            }
                        };
                        if (branch.children !== undefined) {
                            branch.children.push(mBranch);
                        }
                    }
                }
            }
        }
        if (branch.name != 'IXYBERTREEROOT') {
            branch.children = branch.children?.sort(function (a, b) {
                if (a.class && b.class) {
                    if (b.class < a.class) {
                        return 1;
                    }
                    if (b.class > a.class) {
                        return -1;
                    }
                }
                if (a.shape && b.shape) {
                    if (a.shape < b.shape) {
                        return -1;
                    }
                    if (a.shape > b.shape) {
                        return 1;
                    }
                }
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }

                return 0;
            });
            // branch.children = branch.children?.sort((a, b) => a.name > b.name ? 1 : -1)?.sort((a, b) => (a.class && b.class) ? (a.class > b.class ? -1 : 1):1 );
        }

        return branch;
    }

    const TreeScroll = React.useRef<HTMLDivElement>(null);
    const [elementPosition, setElementPosition] = useState<number | null>(null);

    function expandTreeByPath(path: string, tree: any): any {
        const pathParts = path.split('/');
        let totalElements = 0;
        let selectedPosition = 0;

        function findNode(currentNode: any, remainingPathParts: string[], currentPosition: number): any {
            const [nextPart, ...restParts] = remainingPathParts;
            let newPosition = currentPosition;

            if (currentNode.children.length > 0) {
                if (currentNode.name === 'IXYBERTREEROOT') {
                    currentNode.stateBranch = true;
                }

                currentNode.children = currentNode.children.map((child: any) => {
                    totalElements++;
                    newPosition++;

                    if (child.name === nextPart) {
                        if (restParts.length === 0) {
                            selectedPosition = newPosition + 1;
                        }

                        let parent = propTree.current.get(currentNode.id);
                        let newChild =
                            currentNode.name === 'IXYBERTREEROOT' ? parent.objectmodel : parent.blocks[nextPart];

                        const updatedBranch = updateBranchConf(
                            newChild,
                            classNameArr.current.get(newChild.ClassName),
                            parent,
                            true
                        );

                        const updatedChildren = [...updatedBranch.children];

                        let stopCalculate = false;

                        for (let i = 0; i < updatedChildren.length; i++) {
                            if (child.children[i]?.name == restParts[0]) stopCalculate = true;
                            if (child.children.length > 0 && child.children[i]?.children.length > 0) {
                                updatedChildren[i] = { ...child.children[i] };

                                // if (child.children[i].name != restParts[0] && !stopCalculate) {
                                //     newPosition += countNestedElements(child.children[i]) - 1;
                                // }
                                if (!stopCalculate) {
                                    newPosition += countNestedElements(child.children[i]) - 1;
                                }
                            }
                        }

                        updatedBranch.children = updatedChildren;

                        if (restParts.length > 0) {
                            return findNode(updatedBranch, restParts, newPosition);
                        } else {
                            updatedBranch.path = `IXYBERTREEROOT/${path}`;

                            setState((prevState) => ({
                                ...prevState,
                                tree: prevState.tree ? [...prevState.tree] : [],
                                selectedBranch: updatedBranch,
                                selectedData: newChild
                            }));

                            return { ...updatedBranch, updated: true };
                        }
                    }
                    return child;
                });
            }

            return currentNode;
        }

        const updatedTree = findNode(tree, pathParts, 0);
        setElementPosition(selectedPosition);
        return updatedTree;
    }

    const countNestedElements = (node: any): number => {
        let count = 1;
        if (node.children && node.stateBranch) {
            for (const child of node.children) {
                count += countNestedElements(child);
            }
        }
        return count;
    };

    useEffect(() => {
        const container = TreeScroll.current;

        const checkScroll = () => {
            if (TreeScroll.current && elementPosition) {
                const scrollContainer = TreeScroll.current;

                const scrollToSelectedElement = (position: number, timer: number) => {
                    if (scrollContainer && scrollContainer.scrollHeight > scrollContainer.clientHeight) {
                        const element = scrollContainer.querySelector('.branch') as HTMLElement;
                        if (element) {
                            const rect = element.getBoundingClientRect();
                            const elementHeightPx = +rect.height.toFixed(3);
                            const scrollPosition = (position - 1) * elementHeightPx;

                            scrollContainer.scrollTo({
                                top: scrollPosition,
                                behavior: 'smooth'
                            });

                            setElementPosition(null);
                        }
                    } else {
                        const timeoutTime = 100;

                        if (timer < 1000) {
                            setTimeout(() => {
                                scrollToSelectedElement(position, timer + timeoutTime);
                            }, timeoutTime);
                        }
                    }
                };

                scrollToSelectedElement(elementPosition, 0);
            }
        };

        const resizeObserver = new ResizeObserver(() => {
            checkScroll();
        });

        if (container) {
            resizeObserver.observe(container);
        }

        checkScroll();

        return () => {
            if (container) {
                resizeObserver.unobserve(container);
            }
        };
    }, [TreeScroll, elementPosition]);

    //запись дочерних параметров для родительского элемента
    function getChildrenParameters(obj: any): ITreeAPC_branch[] {
        const processedQuality: ITreeAPC_branch[] = [];

        const qualityBranch: ITreeAPC_branch = {
            type: 'folder',
            name: obj.name,
            address: obj.address,
            enable: obj.Enable,
            children: obj.children
        };
        processedQuality.push(qualityBranch);

        return processedQuality;
    }
    //Проверяем вложенные элементы НА ПОДУМАТЬ !!!
    // function checkType(obj: any) {
    //     let type = true;
    //     for (var key in obj) {
    //         let t = findType(obj[key], key).ReturnTypes;
    //         if (t[0].indexOf('System.Collections.Generic.Dictionary') > -1) {
    //             type = true
    //         } else {
    //             type = false
    //         }
    //     }
    //     return type
    // }

    function genTree(data: any, type: any, selectedData?: any) {
        selectedData = selectedData || state.selectedData || {};

        let tree = updateBranchConf(data, type, selectedData);

        setState((prevState) => ({
            ...prevState,
            tree: [tree]
        }));
    }

    async function updateDate(id: string, propName: string, value: any) {
        const rez = await hmiclientbase.SettingsChangeProperty(id, propName, value);
        if (rez === 'true') {
            const ids = [state.selectedBranch?.id, state.selectedBranch?.pid].filter(
                (i): i is string => i !== undefined
            );

            if (state.selectedBranch?.class?.includes('iXyberBaseLib.Source')) ids.push(id);

            if (ids.length > 0) {
                const objects = await hmiclientbase.SettingsGetObjectsDto(ids);
                for (const [_, value] of Object.entries(objects) as [any]) {
                    propTree.current.set(value.id, value);
                }
                if (state.selectedBranch?.id && state.selectedBranch?.pid) {
                    await getBranchData(
                        state.selectedBranch,
                        state.selectedBranch?.id,
                        state.selectedBranch.stateBranch
                    );
                }
            }
        }
    }

    // function updateDate(id: string, propName: string, value: any) {
    //     hmiclientbase.SettingsChangeProperty(id, propName, value).then((rez: any) => {
    //         if (rez === 'true') {
    //             hmiclientbase.SettingsGetObjectDto(id).then((data: any) => {
    //                 propTree.current.set(id, data);

    //                 // const safeData = removeCircularReferences(yourObject);
    //                 setState((prevState) => {
    //                     return {
    //                         ...prevState,
    //                         selectedData: prevState.selectedData.id === data.id ? data : prevState.selectedData
    //                         // selectedData: prevState.selectedData.id === data.id ? data : JSON.parse(JSON.stringify(prevState.selectedData))
    //                     };
    //                 });
    //             });
    //         }
    //     });
    // }

    function resizeWidthWindow(e: React.MouseEvent) {
        let width: number = e.pageX - 23;
        if (width > 150 && width < 750 && state.resizeTree) {
            setState((prevState) => ({
                ...prevState,
                widthWindowTree: width
            }));
        }
    }

    function openDictionaryTable(typeKey: string, typeValue: string, key: any) {
        let tempSelID = '' + state.selectedData.id;
        let wnd: IWindowUnit = {
            x: 400,
            y: 300,
            mode: 'free',
            children: (
                <DictionaryTable
                    inpObj={state.selectedData[key!]}
                    typeKey={typeKey}
                    typeValue={typeValue}
                    closeCB={() => {
                        context.closeWindowUnit(wnd);
                    }}
                    saveCB={(obj: any) => {
                        dictionaryTableUpdate(tempSelID, key, obj);
                        context.closeWindowUnit(wnd);
                    }}
                />
            ),
            // keyID: '' + state.selectedData.id
            keyID: generateRandomKey()
        };
        context.createWindowUnit(wnd);
    }

    function openPropertyEditor(key: string, typeStr: string) {
        let tempSelID = '' + state.selectedData.id;
        let wnd: IWindowUnit = {
            x: 400,
            y: 300,
            mode: 'free',
            children: (
                <PropertyEditWindow
                    inpObj={state.selectedData[key!]}
                    id={state.selectedData.id}
                    propsName={key}
                    typeValue={typeStr}
                    closeCB={() => {
                        context.closeWindowUnit(wnd);
                    }}
                    saveCB={(id: string, propsName: string, obj: any) => {
                        updateDate(id, propsName, obj);
                        context.closeWindowUnit(wnd);
                    }}
                />
            ),
            keyID: generateRandomKey()
        };
        context.createWindowUnit(wnd);
    }

    function openExeFunc(id: string, returnType: any) {
        let nameMethod: string = returnType?.Name ? returnType?.Name : '';
        let wnd: IWindowUnit = {
            x: 400,
            y: 300,
            mode: 'free',
            children: (
                <ExeFunc
                    id={id}
                    returnTypes={returnType}
                    closeCB={() => {
                        context.closeWindowUnit(wnd);
                    }}
                />
            ),
            // keyID: '' + state.selectedData.id,
            keyID: generateRandomKey(),
            headerText: `${state.selectedData.name} (${nameMethod})`
        };
        context.createWindowUnit(wnd);
    }

    function dictionaryTableUpdate(id: any, key: string, obj: any) {
        if (key !== undefined) {
            updateDate(id, key, obj);
            //this.updateDate(this.state.selectedData.id, this.state.dictionaryTableKeyInObj, JSON.stringify(obj));
        }
    }

    function openEvents(eventId: string) {
        let wnd: IWindowUnit = {
            x: 400,
            y: 300,
            mode: 'free',
            children: (
                <EventElement
                    eventIdObject={eventId}
                    closeCB={() => {
                        context.closeWindowUnit(wnd);
                    }}
                />
            ),
            // keyID: '' + state.selectedData.id,
            keyID: generateRandomKey(),
            headerText: 'Events'
        };
        context.createWindowUnit(wnd);
    }

    function generateRandomKey() {
        return Math.random().toString(36).substring(2, 12) + Math.random().toString(36).substring(2, 12);
    }

    function openBindings(pId: string) {
        let wnd: IWindowUnit = {
            x: 400,
            y: 300,
            mode: 'free',
            children: (
                <BindingsElement
                    pIdObject={pId}
                    closeCB={() => {
                        context.closeWindowUnit(wnd);
                    }}
                />
            ),
            keyID: generateRandomKey(),
            headerText: 'Bindings'
        };
        context.createWindowUnit(wnd);
    }

    async function openRefDevice(refId: string) {
        const data = await hmiclientbase.SettingsGetObjectDto(refId);
        const refType = data.rtypestr;
        const tempSelID = '' + refId;
        const wnd: IWindowUnit = {
            x: 400,
            y: 300,
            mode: 'free',
            children: (
                <RefDevice
                    refType={refType}
                    activeObject={data}
                    closeCB={() => {
                        context.closeWindowUnit(wnd);
                    }}
                    saveCB={(rpath: any) => {
                        updateDate(tempSelID, 'rpath', rpath);
                        context.closeWindowUnit(wnd);
                    }}
                />
            ),
            // keyID: '' + state.selectedData.id,
            keyID: generateRandomKey(),
            headerText: 'Reference Device'
        };
        context.createWindowUnit(wnd);
    }

    async function openAddressList(id: string) {
        const data = await hmiclientbase.SettingsGetObjectDto(id);
        const refType = data.refinterface.rtypestr;
        const wnd: IWindowUnit = {
            x: 400,
            y: 300,
            mode: 'free',
            children: (
                <AddressList
                    refType={refType}
                    data={data}
                    closeCB={() => {
                        context.closeWindowUnit(wnd);
                    }}
                    saveCB={(address: any) => {
                        updateDate(id, 'address', address);
                        context.closeWindowUnit(wnd);
                    }}
                />
            ),
            keyID: generateRandomKey(),
            headerText: 'Address List'
        };
        context.createWindowUnit(wnd);
    }

    async function UpdateBase() {
        const response = await hmiclientbase.SettingsUpdateBase();
        if (response) {
            location.reload();
        }
    }

    async function initTree() {
        let baseObj = hmiclientbase.GetBase();

        const updateBaseTree = async (obj: any) => {
            let objClass = await getObjClass(obj.ClassName);

            propTree.current.set(obj.id, obj);

            if (objClass) {
                for (let key = 0; key < objClass.length; key++) {
                    if (typeof obj[objClass[key].Name] === 'object' && obj[objClass[key].Name] !== null) {
                        if (objClass[key].ReturnTypes[0].indexOf('System.Collections.Generic.Dictionary') > -1) {
                            for (let dKey in obj[objClass[key].Name]) {
                                if (obj[objClass[key].Name][dKey].id !== undefined) {
                                    await updateBaseTree(obj[objClass[key].Name][dKey]);
                                }
                            }
                        } else {
                            if (obj[objClass[key].Name].id !== undefined) {
                                await updateBaseTree(obj[objClass[key].Name]);
                            }
                        }
                    }
                }
            }
        };

        await updateBaseTree(baseObj);
    }

    function updateRefMethod(pathBlock: string, classBlock: string, nameFunc: string) {
        if (
            state.selectedData.refobject.id !== undefined &&
            pathBlock !== undefined &&
            nameFunc !== '' &&
            classBlock !== ''
        ) {
            updateDate(state.selectedData.refobject.id, 'rtypestr', classBlock);
            updateDate(state.selectedData.refobject.id, 'rpath', pathBlock);
            updateDate(state.selectedData.refobject.id, 'rmethodName', nameFunc);
            setState((prevState) => ({
                ...prevState,
                openAddRefMethod: false
            }));
        } else {
            alert('error! not object refobject');
        }
    }

    function showToast(message: string) {
        const toast: IToastData = {
            id: GetGuid(),
            message
        };

        setToasts((prevToasts) => [...prevToasts, toast]);

        setTimeout(() => {
            removeToast(toast.id!);
        }, 3 * 1000);
    }

    function removeToast(id: string) {
        setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
    }

    // const comboBoxData: IComboBoxData[] = Array.from(test.current, ([path, obj]) => ({ id: obj.id, value: path }));
    const [comboBoxData, setComboBoxData] = useState<IComboBoxData[]>([]);
    const [selectedPath, setSelectedPath] = useState<SelectedElem>({ id: '', value: '' });

    useEffect(() => {
        hmiclientbasedata
            .SettingsGetPathsType('iXyberBaseLib.Parameter')
            .then((items) => {
                if (!Array.isArray(items)) {
                    console.error('Unexpected data type for items:', items);
                    return [];
                }
                return items.filter((item: string) => !item.includes('TEMPLATES'));
            })
            .then((filteredItems) => {
                if (filteredItems.length === 0) {
                    console.log('No valid items to process.');
                    return;
                }

                const Params: { [key: string]: string[] } = {};
                const uniqueItems = filteredItems.map((item: string) => {
                    const [path, param] = item.split('.');
                    if (Params[path]) {
                        Params[path].push(param);
                    } else {
                        Params[path] = [param];
                    }
                    return path;
                });

                const comboBoxData = [...new Set(uniqueItems)].map((item: string, index: number) => ({
                    id: index.toString(),
                    value: item
                }));

                setComboBoxData(comboBoxData);
            })
            .catch((err) => {
                console.error('Error fetching paths:', err);
            });
    }, [state.reloadBase]);

    return (
        <>
            <div
                style={{
                    height: '100%',
                    width: '100%',
                    fontFamily: 'Roboto'
                }}>
                <div
                    style={{
                        height: '100%',
                        position: 'relative'
                    }}
                    onMouseUp={() => {
                        setState((prevState) => ({
                            ...prevState,
                            resizeTree: false
                        }));
                    }}
                    onMouseMove={(e) => {
                        resizeWidthWindow(e);
                    }}>
                    {state.reloadBase ? (
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexGrow: 1,
                                width: '100%',
                                height: '100%'
                            }}>
                            <img src="static/images/loading_hend.gif" style={{ height: '11em', width: '15em' }} />
                        </div>
                    ) : (
                        <>
                            <Header
                                homeElement={
                                    <Link to={'/ixyber/vision/display/base'} title="Главная">
                                        <IconButton imageUrl="Home" size="medium" />
                                    </Link>
                                }
                                userName={auth.nameUser}
                                isAllowed={auth.settingTrue}
                                isAuthenticated={auth.authenticated}
                                privateElements={
                                    <>
                                        <Link to="/ixyber/vision/display/settingmain" title="Настройки">
                                            <IconButton imageUrl="Setting" size="medium" />
                                        </Link>
                                        <Link to="/ixyber/vision/display/EditorVision" title="Редактор">
                                            <IconButton imageUrl="Editor" size="medium" />
                                        </Link>
                                    </>
                                }
                                callbackLogin={() => {
                                    auth.callbackLogin();
                                }}
                                callbackLogout={() => {
                                    auth.callbackLogout();
                                }}></Header>
                            <div
                                style={{
                                    height: 'calc(100% - 60px)',
                                    display: 'flex'
                                }}>
                                <div
                                    className="no-print"
                                    style={{
                                        display: 'flex',
                                        height: '100%',
                                        width: state.widthWindowTree + 'px',
                                        paddingRight: '5px',
                                        borderRadius: '10px',
                                        background: 'white',
                                        boxShadow: '4px 4px 4px rgba(0, 0, 0, 0.05)',
                                        margin: '0.5em 0.5em 1em 0',
                                        // overflow: (this.state.openWindowTree) ? 'auto' : 'hidden',
                                        maxWidth: state.openWindowTree ? state.widthWindowTree + 'px' : '3.2em',
                                        transition: !state.resizeTree ? 'margin-left .3s, max-width .3s' : ''
                                    }}>
                                    <div
                                        style={{
                                            display: state.openWindowTree ? 'block' : 'none',
                                            height: '100%',
                                            width: '100%',
                                            maxWidth: state.openWindowTree ? state.widthWindowTree + 'px' : '0',
                                            transition: !state.resizeTree
                                                ? 'display .3s, opacity .3s, max-width .3s'
                                                : ''
                                        }}>
                                        <div
                                            style={{
                                                // cursor: 'crosshair',
                                                display: 'flex',
                                                // justifyContent: 'space-between',
                                                gap: '10px',
                                                alignItems: 'center',
                                                height: '2.5em',
                                                padding: '0 20px',
                                                userSelect: 'none'
                                            }}>
                                            <svg
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                    setState((prevState) => ({
                                                        ...prevState,
                                                        openWindowTree: false
                                                    }));
                                                }}
                                                width="15"
                                                height="15"
                                                viewBox="0 0 15 15"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M10.9265 4.16948L7.56348 7.5913C7.34154 7.81727 7.34154 8.18159 7.56348 8.40986L10.9242 11.8317C11.0352 11.9447 11.1801 12 11.325 12C11.47 12 11.6149 11.9447 11.7259 11.8317C11.9478 11.6057 11.9478 11.2414 11.7259 11.0154L8.76374 7.99943L11.7281 4.98573C11.9501 4.75976 11.9501 4.39545 11.7281 4.16948C11.5062 3.94351 11.1484 3.94351 10.9265 4.16948Z"
                                                    fill="#AEAEAE"
                                                />
                                                <path
                                                    d="M7.52717 4.16948L4.16645 7.5913C3.94452 7.81727 3.94452 8.18159 4.16645 8.40986L7.52717 11.8317C7.63814 11.9447 7.78308 12 7.92801 12C8.07295 12 8.21789 11.9447 8.32885 11.8317C8.55079 11.6057 8.55079 11.2414 8.32885 11.0154L5.36671 7.99943L8.32885 4.98573C8.55079 4.75976 8.55079 4.39545 8.32885 4.16948C8.10692 3.94351 7.74911 3.94351 7.52717 4.16948Z"
                                                    fill="#AEAEAE"
                                                />
                                            </svg>
                                            <Search
                                                data={comboBoxData}
                                                selected={selectedPath.id}
                                                type={'search'}
                                                onClick={(item) => {
                                                    setSelectedPath(item);
                                                    expandTreeByPath(item.value, state.tree![0]);
                                                }}
                                                placeholder="Поиск"
                                                onEnter={(item: any) => {
                                                    expandTreeByPath(selectedPath.value, state.tree![0]);
                                                }}
                                                width="100%"
                                            />
                                        </div>

                                        <div
                                            style={{
                                                height: 'calc(100% - 2.8em)',
                                                width: '100%'
                                            }}>
                                            <div
                                                ref={TreeScroll}
                                                className={css_class.treeContainer}
                                                style={{
                                                    height: 'calc(60% - 2.5em)',
                                                    // borderBottom: '1px solid black',
                                                    position: 'relative',
                                                    overflow: 'auto'
                                                }}>
                                                <div
                                                    style={{
                                                        paddingLeft: '20px'
                                                    }}>
                                                    <TreeAPC
                                                        inpArr={state.tree ? state.tree : []}
                                                        selectedBranch={state.selectedBranch}
                                                        copyPasteObject={state.copyPasteObject}
                                                    />
                                                </div>
                                                <div className={css_class.gradientBottom} />
                                            </div>
                                            <div
                                                style={{
                                                    height: '2.5em',
                                                    borderBottom: '1px solid black',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center'
                                                }}>
                                                <Button
                                                    text={'Применить'}
                                                    // width={100}
                                                    // height={24}
                                                    size="small"
                                                    styleType="tinted"
                                                    onClick={() => {
                                                        setState((prevState) => ({
                                                            ...prevState,
                                                            reloadBase: true
                                                        }));
                                                        UpdateBase();
                                                    }}
                                                />
                                            </div>
                                            <div
                                                style={{
                                                    height: '40%',
                                                    width: '100%',
                                                    boxSizing: 'border-box',
                                                    padding: '0.5em 0 0 0.5em',
                                                    overflow: 'hidden'
                                                }}>
                                                <TableForEdit
                                                    data={state.selectedData}
                                                    type={classNameArr.current.get(state.selectedData.ClassName)}
                                                    changeInput={(id: string, propName: string, value: any) => {
                                                        updateDate(id, propName, value);
                                                    }}
                                                    openDictionaryObj={(
                                                        obj: any,
                                                        typeKey: string,
                                                        typeValue: string
                                                    ) => {
                                                        openDictionaryTable(typeKey, typeValue, obj);
                                                    }}
                                                    openRefDevice={(refId: string) => {
                                                        openRefDevice(refId);
                                                    }}
                                                    openAddressList={(id: string) => {
                                                        openAddressList(id);
                                                    }}
                                                    openExeFunc={(id: string, returnType: any) => {
                                                        openExeFunc(id, returnType);
                                                    }}
                                                    openEvents={(eventId: string) => openEvents(eventId)}
                                                    openBindings={(pId: string) => openBindings(pId)}
                                                    openPropertyEditor={(key: string, typeStr: string) =>
                                                        openPropertyEditor(key, typeStr)
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            background: '#fff',
                                            width: '0.2em',
                                            overflow: state.openWindowTree ? 'auto' : 'hidden',
                                            maxWidth: state.openWindowTree ? '0.2em' : '0',
                                            cursor: 'col-resize',
                                            transition: 'max-width .3s'
                                        }}
                                        onDoubleClick={() => {
                                            setState((prevState) => ({
                                                ...prevState,
                                                widthWindowTree: 400
                                            }));
                                        }}
                                        onMouseDown={(e) => {
                                            setState((prevState) => ({
                                                ...prevState,
                                                resizeTree: true,
                                                resizeMDPoint: e.pageX / 10
                                            }));
                                        }}></div>
                                    <div
                                        style={{
                                            cursor: 'pointer',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            height: '2.8em',
                                            overflow: !state.openWindowTree ? 'auto' : 'hidden',
                                            maxWidth: !state.openWindowTree ? '3.2em' : '0em',
                                            userSelect: 'none'
                                        }}
                                        onClick={() => {
                                            setState((prevState) => ({
                                                ...prevState,
                                                openWindowTree: true
                                            }));
                                        }}>
                                        {
                                            <svg
                                                style={{ paddingLeft: '20px' }}
                                                width="20"
                                                height="20"
                                                viewBox="0 0 20 20"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M1 2H21M1 10.4615H21M1 18.9231H21"
                                                    stroke="#AEAEAE"
                                                    strokeWidth="1.4"
                                                    strokeLinecap="round"
                                                />
                                            </svg>
                                        }
                                    </div>
                                </div>
                                <div
                                    style={{
                                        height: '100%',
                                        flexGrow: 1,
                                        borderRadius: '10px',
                                        boxShadow: '-2px -2px 4px rgba(0, 0, 0, 0.05), 2px 2px 4px rgba(0, 0, 0, 0.05)',
                                        margin: '0.5em 0.5em 1em 0.5em',
                                        width: `calc(95% - ${state?.widthWindowTree}px)`,
                                        background: '#fff'
                                    }}>
                                    <div
                                        style={{
                                            height: '100%'
                                        }}>
                                        {state.selectedData?.ClassName?.includes('FileScript') && (
                                            <>
                                                <div
                                                    style={{
                                                        height: 'calc(100% - 3em)'
                                                    }}>
                                                    <MonacoEditor
                                                        language="python"
                                                        value={state.selectedData.Context}
                                                        callbacOnChange={(newValue: string) => {
                                                            setTextMonaco(newValue);
                                                        }}
                                                    />
                                                </div>
                                                <Button
                                                    text={'Сохранить'}
                                                    size="small"
                                                    styleType="tinted"
                                                    onClick={() => {
                                                        textMonaco !== null &&
                                                            updateDate(state.selectedData.id, 'Context', textMonaco);
                                                    }}></Button>
                                            </>
                                        )}

                                        {(state.selectedData?.ClassName?.includes('Block') ||
                                            state.selectedData?.ClassName?.includes('Templates')) && (
                                            <div
                                                style={{
                                                    height: 'calc(100% - 3em)'
                                                }}>
                                                <BlockPage
                                                    propTree={propTree}
                                                    selectData={state.selectedData}
                                                    addElement={async () => {
                                                        let listTypes: any = {};
                                                        await hmiclientbase
                                                            .SettingsGetChildTypes(state.selectedData.id)
                                                            .then((data: any) => {
                                                                if (data.New !== undefined) {
                                                                    listTypes = data;
                                                                }
                                                            });

                                                        setState((prevState) => ({
                                                            ...prevState,
                                                            openAddBlockMenu: true,
                                                            addBlockListTypes: listTypes
                                                        }));
                                                    }}
                                                    delElement={(idBlocks: string[]) => {
                                                        setState((prevState) => ({
                                                            ...prevState,
                                                            openDelBlocksMenu: true,
                                                            idBlocks: idBlocks
                                                        }));
                                                    }}
                                                    changeSelectElement={(idElement: string) => {
                                                        /*
                                                                if(this.state.selectedBranch?.children != undefined){
                                                                    for(let branch of this.state.selectedBranch.children){
                                                                        if(branch.id == idElement){
                                                                            this.getConf(branch, idElement);
                                                                            break;
                                                                        }
                                                                    }
                                                                }
                                                                */
                                                    }}
                                                    changeInput={(id: string, propName: string, value: any) => {
                                                        updateDate(id, propName, value);
                                                    }}
                                                />
                                            </div>
                                        )}
                                        {/*<DistributionArea id='test' />*/}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <PopupMessage />
            {state.openRefObjectWindow && (
                <RefObjectsWindow
                    selectedData={state.selectedData || ''}
                    closeCB={() => {
                        setState((prevState) => ({ ...prevState, openRefObjectWindow: false }));
                    }}
                />
            )}
            {state.openContextMenu && (
                <ContextMenu
                    position={state.positionContextMenu!}
                    children={state.elemContextMenu}
                    closeCM={() => {
                        closeContextMenu();
                    }}
                />
            )}
            {state.openAddBlockMenu && (
                <AddBlockWindow
                    isButtonLoading={isButtonLoading}
                    closeCM={() => {
                        // AddBlock('', '', '');
                        setState((prevState) => ({
                            ...prevState,
                            openAddBlockMenu: false
                        }));
                    }}
                    createCB={(name: string, type: string, style: string, templateBindings: string) => {
                        AddBlock(name, type, style, templateBindings);
                    }}
                    listObj={state.addBlockListTypes}
                    selectedBranch={state.selectedBranch || undefined}
                />
            )}
            {state.openDelBlockMenu && (
                <DelBlockWindow
                    closeCM={() => {
                        setState((prevState) => ({
                            ...prevState,
                            openDelBlockMenu: false
                        }));
                    }}
                    isButtonLoading={isButtonLoading}
                    delCB={(idBlock: string, deleteAll: boolean) => {
                        DelBlock(idBlock, deleteAll);
                    }}
                    idBlock={state.addBlockParentId || ''}
                    nameBlock={state.selectedBranch?.name || ''}
                />
            )}
            {state.openDelBlocksMenu && (
                <DelBlocksWindow
                    closeCM={() => {
                        setState((prevState) => ({
                            ...prevState,
                            openDelBlocksMenu: false
                        }));
                    }}
                    delCB={(idBlocks: string[], deleteAll: boolean) => {
                        DelBlocks(idBlocks, deleteAll);
                    }}
                    idBlocks={state.idBlocks || []}
                />
            )}
            {state.openImportMenu && (
                <ImportWindow
                    closeCM={() => {
                        setState((prevState) => ({
                            ...prevState,
                            openImportMenu: false
                        }));
                    }}
                    createCB={(pid: string, file: any) => {
                        ImportObject(pid, file);
                    }}
                    pid={state.selectedData.id}
                />
            )}
            {state.openExportMenu && (
                <ExportWindow
                    closeCM={() => {
                        setState((prevState) => ({
                            ...prevState,
                            openExportMenu: false
                        }));
                    }}
                    createCB={(
                        pid: string,
                        separator: any,
                        namesToSend: any[],
                        typesToSend: any[],
                        isExportAll: boolean
                    ) => {
                        ExportObject(pid, separator, namesToSend, typesToSend, isExportAll);
                    }}
                    pid={state.selectedData.id}
                />
            )}
            {state.openAddNewMnemo && (
                <AddNewMnemoWindow
                    closeCM={() => {
                        AddNewMnemo('');
                    }}
                    createCB={(name: string, type: string) => {
                        /* this.AddBlock(name, type) */
                    }}
                />
            )}
            {state.openAddRefMethod && (
                <WindowSettingRefMethod
                    closeCB={() => {
                        setState((prevState) => ({
                            ...prevState,
                            openAddRefMethod: false
                        }));
                    }}
                    saveCB={(pathBlock, classBlock, nameFunc) => {
                        updateRefMethod(pathBlock, classBlock, nameFunc);
                    }}
                />
            )}
            <ToastList data={toasts} position="top_center" removeToast={removeToast} />
        </>
    );
};
//Settings.contextType = WindowGlobalAreaContext;
export default observer(Settings);
